var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CalendarSvg from './calendar.icon.svg';
export const CalendarIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: CalendarSvg }));
_react_refresh_temp_1 = CalendarIcon;
$RefreshReg$(_react_refresh_temp_1, "CalendarIcon");
